module.exports = __webpack_public_path__ + "static/img/service3.055636c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service3.jpg
// module id = tRjD
// module chunks = 0